import * as PDFObject from 'pdfobject';
export class OverlayManager {
    constructor(overlayId = 'overlay', hideOnClick = true) {
        let me = this;
        let overlayElement = document.getElementById(overlayId);
        if (overlayElement == null) {
            overlayElement = document.createElement('div');
            overlayElement.id = overlayId;
        }
        this.OverlayElement = overlayElement;
        this.OverlayElement.className += ' overlay';
        if (hideOnClick) {
            this.OverlayElement.className += " overlay-hide-on-click";
            this.OverlayElement.onclick = function () { me.hide(); };
        }
        document.body.appendChild(this.OverlayElement);
    }
    show() {
        this.OverlayElement.style.display = "block";
    }
    hide() {
        this.OverlayElement.style.display = "none";
    }
}
class ClosableOverlayManager extends OverlayManager {
    constructor(contentId = 'overlay-content', hideOnClick = true) {
        super(contentId + '-parent', hideOnClick);
        let me = this;
        let closeButtonId = `${this.OverlayElement.id}-close-button`;
        this.ContentWrapperId = `${this.OverlayElement.id}-content-wrapper`;
        this.OverlayElement.innerHTML = `<div class='overlay-flex'><div id='${closeButtonId}' class='close-button'><i class='fal fa-xmark'></i></div><div id='${this.ContentWrapperId}' class='content-wrapper'></div></div>`;
        document.getElementById(closeButtonId).onclick = function () { me.hide(); };
        let contentWrapperElement = document.getElementById(this.ContentWrapperId);
        let contentElement = document.getElementById(contentId);
        if (contentWrapperElement && contentElement) {
            contentWrapperElement.appendChild(contentElement);
        }
    }
}
export class PdfOverlayManager extends ClosableOverlayManager {
    constructor(url, overlayId = 'overlay', hideOnClick = true) {
        super(overlayId, hideOnClick);
        this.IsLoaded = true;
        this._isShown = false;
        let contentWrapperElement = document.getElementById(this.ContentWrapperId);
        contentWrapperElement.className += ' pdf-renderer';
        this._url = url;
    }
    show() {
        if (!this._isShown) {
            try {
                let me = this;
                this._isShown = true;
                var options = {
                    forceIframe: BrowserDetector.IsSafari
                };
                PDFObject.embed(this._url, `#${this.ContentWrapperId}`, options);
                let $embed = $(`#${this.ContentWrapperId} embed, #${this.ContentWrapperId} iframe`);
                if ($embed.length > 0) {
                    this.IsLoaded = false;
                    $embed.on('load', function () {
                        me.IsLoaded = true;
                        PleaseWait.hide();
                    });
                }
            }
            catch (ex) {
                console.error(ex);
            }
        }
        if (!this.IsLoaded)
            PleaseWait.show();
        super.show();
    }
}
window.ClosableOverlayManager = ClosableOverlayManager;
window.OverlayMananger = OverlayManager;
window.PdfOverlayManager = PdfOverlayManager;
